import { nodeCategories } from '../constants/nodeCategories';
import { AI_NODE_TYPES, getDefaultAiConfig } from '../../../config/aiConfig';

const metaByType = {};

nodeCategories.forEach((category) => {
  category.nodes.forEach((node) => {
    metaByType[node.nodeType] = {
      nodeType: node.nodeType,
      type: node.type,
      label: node.label,
      subtitle: node.subtitle,
      color: category.color,
      icon: node.icon,
      hasInput: node.hasInput,
      hasOutput: node.hasOutput,
    };
  });
});

/** Restore icon/color/labels when loading from Supabase (icons are not persisted). */
export function enrichNodeConfig(config = {}) {
  const meta = metaByType[config.nodeType];
  const aiDefaults = AI_NODE_TYPES.has(config.nodeType) && !config.aiProvider
    ? getDefaultAiConfig()
    : {};
  if (!meta) return { ...aiDefaults, ...config };
  const displayLabel =
    config.name
    || (config.nodeType === 'kGateway' && config.gatewayId ? config.title : null)
    || config.title
    || config.label
    || meta.label;
  return {
    ...meta,
    ...aiDefaults,
    ...config,
    title: displayLabel,
    label: config.nodeType === 'kGateway' && config.name ? config.name : (config.label || meta.label),
    subtitle: config.subtitle || meta.subtitle,
    color: config.color || meta.color,
    icon: meta.icon,
  };
}

/** Strip non-serializable fields before saving to Supabase. */
export function sanitizeNodeConfig(config = {}) {
  const { icon, ...rest } = config;
  return rest;
}

export function getNodeDragPayload(node, category) {
  return {
    type: node.type,
    nodeType: node.nodeType,
    label: node.label,
    subtitle: node.subtitle,
    color: category.color,
    hasInput: node.hasInput,
    hasOutput: node.hasOutput,
  };
}
